export default __webpack_public_path__ + "static/media/card_content_2.47382e25.png";